var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgReleaseVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.25 60.6172C69.25 61.0391 69.4609 61.25 69.8828 61.25C69.9883 61.25 70.0938 61.25 70.1992 61.25L75.1562 58.4023C75.5781 58.0859 76.3164 58.0859 76.7383 58.4023L81.6953 61.25C81.8008 61.25 81.9062 61.25 82.0117 61.25C82.4336 61.25 82.6445 61.0391 82.6445 60.6172V47.75H91.082C93.9297 47.75 96.1445 50.0703 96.1445 52.8125V69.6875C96.1445 72.5352 93.9297 74.75 91.082 74.75H60.8125C57.9648 74.75 55.75 72.5352 55.75 69.6875V52.8125C55.75 50.0703 57.9648 47.75 60.8125 47.75H69.25V60.6172ZM105.531 83.293C106.902 85.1914 106.48 87.8281 104.582 89.1992L91.293 99.0078C88.7617 100.801 85.8086 101.75 82.75 101.75H65.875H49C47.1016 101.75 45.625 100.273 45.625 98.375V91.625C45.625 89.832 47.1016 88.25 49 88.25H52.7969L57.543 84.4531C59.9688 82.5547 62.9219 81.5 65.9805 81.5H74.3125H76H82.75C84.543 81.5 86.125 83.082 86.125 84.875C86.125 86.7734 84.543 88.25 82.75 88.25H76H74.3125C73.3633 88.25 72.625 89.0938 72.625 89.9375C72.625 90.8867 73.3633 91.625 74.3125 91.625H86.9688L99.625 82.3438C101.523 80.9727 104.16 81.3945 105.531 83.293ZM65.9805 88.25H65.875C65.9805 88.25 65.9805 88.25 65.9805 88.25Z",
    fill: "url(#paint0_linear_20482_537116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20482_537116",
    x1: 76,
    y1: 48,
    x2: 76,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgReleaseVoucher);
export default __webpack_public_path__ + "static/media/img_release_voucher.f8fbd62faedfd729b9b79a7301f4c66b.svg";
export { ForwardRef as ReactComponent };